angular.module('impactx.productview').controller('ProductViewCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'TranslationService',
    'BackService',
    'ToastService',
    '$context',
    'ProductViewService',
    'ProductSelectionService',
    'SearchService',
    '$redirect',
    'ToolbarService',
    ProductViewCtrl
]);

function ProductViewCtrl($scope, dataGen, $routeParams, TranslationService, BackService, ToastService, $context, ProductViewService, ProductSelectionService, SearchService, $redirect, ToolbarService) {
    var self = this;

    dataGen.getData($scope, {vcatId: $routeParams.id}, "/productview/view").then(function() {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');

        if($routeParams.activate) {
            ProductViewService.activateProductView($routeParams.id);
        }

        angular.copy($scope.data.products, ProductViewService.validProducts);
        angular.copy($scope.data.lots, ProductViewService.lotFilter);

        defineButtons();
    });

    self.save = function() {
        delete $scope.data.products;
        return dataGen.postAsForm($scope, {vcat: $scope.data}, "/productview/save").then(function() {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            self.deactivateProductView();
            BackService.back();
        });
    };

    self.delete = function() {
        var ids = [];
        ids.push($scope.data.id);
        return dataGen.postAsForm({}, {ids: ids}, "/productview/delete").then(function(data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                if(data.trns.vcatDeactivated) {
                    ToastService.openStandardToast(data.trns.vcatDeactivated);
                }
            });
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    self.deactivateProductView = function() {
        ProductViewService.deactivateActiveProductView().then(function(data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                if (data)
                {
                    ToastService.openStandardToast(data.trns.vcatDeactivated);
                }
            });
        });
    };
    
    self.viewValidProducts = function() {
        var config = {
            title: $scope.trns.products,
            locals: {
                hideDefaultAction: true,
                vcat: {id: $scope.data.id},
                itemActions: [{
                    action: self.removeProduct,
                    label: $scope.trns.remove,
                    reloadAfter: true
                }],
                listActions: [{
                    action: self.removeAllProducts,
                    label: $scope.trns.removeAll,
                    closeAfter: true
                }],
                forProductView: true
            }
        };
        ProductSelectionService.open(config).then(function(){
            $redirect.reload();
        });
    };

    self.viewInvalidProducts = function() {
        // the configured controller has special handling for actions,
        // so no need to provide anything other than the label
        // also hideDefaultAction and hideFilter are always true in this controller
        var config = {
            title: $scope.trns.invalidProducts,
            locals: {
                vcat: {id: $scope.data.id},
                itemActions: [{
                    label: $scope.trns.remove
                }],
                listActions: [{
                    label: $scope.trns.removeAll
                }],
                forProductView: true
            },
            controller: 'ProductViewInvalidProductsCtrl'
        };
        ProductSelectionService.open(config).then(function(){
            $redirect.reload();
        });
    };

    self.removeProduct = function(product, index) {
        return ProductViewService.removeProductsFromProductView($scope.data.id, [product.id]).then(function() {
            SearchService.consumableTopIndexOtherProductSearch.value = index;
        });
    };

    self.removeAllProducts = function() {
        return dataGen.postAsForm({}, {vcatId: $scope.data.id}, "/productview/remove/product/allValid").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: isEditable
            },
            {
                label: $scope.trns.addElements,
                linkFunction: getSearchLink,
                type: 'link',
                condition: isEditable
            }
        ];
        ToolbarService.backButtonCallback(self.deactivateProductView);
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return $scope.data.id > 0;
    }

    function getSearchLink() {
        return "search"
    }
}